import React, { Component } from  'react';


class ExampleSelect extends Component {

  render() {
    return <select
        id="example-select"
        className="custom-select custom-select-sm mr-1"
        style={{maxWidth: "300px"}}
        onChange={this.onChange.bind(this)}
      >
        <option value="">Select the example</option>
        {
          this.props.examples.map((example, i) => {
            return <option key={i} value={example.value}>{example.title}</option>
          })
        }
      </select>
  }

  onChange(event) {

    let val = event.target.value;
    if (val !== "") {

      let selectedExample = this.props.examples.find(eg => eg.value === val);
      this.props.setupExample(selectedExample)

    }
  }


}

export default ExampleSelect;
